import UserWebhooksCard from '../../../components/UserWebhooksCard';

export default function WebhooksSection() {
  return <UserWebhooksCard />;
}
